// @ts-nocheck
import { Button, Modal } from "antd";
import { useEffect, useState, useImperativeHandle } from "preact/hooks";
import { forwardRef } from "react";
import { h } from "preact";
import { useForm } from "react-hook-form";
import BaseForm from "../../../../components/form";
import { useMessage } from "../../../../hooks/useMessage";
import { FORM_MAINTENANCE_TECH_CONFIRM_GET_JOB } from "../../constants/forms";
import { IPropsModal } from "../../interface/modal";
import {
  ContainerConfirmGetJob,
  ContainerModalFooterSingle,
} from "../../styled";
import { Text } from "../../../../components/text";
import { useSelector } from "react-redux";
import { MECHANIC_COMFIRM, POST } from "../../../../services";

const defaultValues = {
  CustomerName: "",
  SaleCode: "",
  UserCreate: "",
  claimId: "",
  createDate: "",
  customerCode: "",
  description: "",
  deviceId: "",
  deviceLotId: "",
  maintainId: "",
  maintainStatus: "",
  maintainType: "",
  remaining: "",
  team: "",
  zone: "",
  main_confirm_worker: "",
  main_confirm_start_date: "",
  main_name_tech: "",
  main_confirm_remark: "",
};

export const ModalConfirmTechGetJob = forwardRef<any, IPropsModal>((props, ref) => {
  const userState: any = useSelector((state: IAuthState) => state.auth.user);
  const { onCallbackEdit, onBeforeConfirm } = props;
  const [visible, setVisible] = useState(false);
  const [deviceId, setDeviceId] = useState("");
  const [MainId, setMaineId] = useState("");
  const [loading, setLoading] = useState(false);
  const { openMessage } = useMessage();
  const { control, setValue, getValues, reset, handleSubmit } = useForm({
    defaultValues,
  });

  useEffect(() => {
    !visible && reset();
  }, [visible]);

  useImperativeHandle(ref, () => ({
    async openModal(e) {
      try {
        setValue("main_name_tech", userState.fullName);
        setValue("main_confirm_start_date", e.createDate);
        setVisible(true);
        setDeviceId(e.deviceId);
        setMaineId(e.maintainId);
        for (const key in e) {
          const element = e[key];
          if (key in defaultValues) {
            setValue(key as keyof typeof defaultValues, element);
          }
        }
        setValue("main_confirm_worker", userState.fullName);
      } catch (error) {
        console.log(error);
      }
    },
  }));

  const onConfirm = async () => {
    try {
      setLoading(true);
      onBeforeConfirm && await onBeforeConfirm();
      const { maintainId, main_confirm_remark } = getValues();
      const res = await POST(MECHANIC_COMFIRM, {
        maintainId,
        remark: main_confirm_remark,
      });
      if (!res.success) {
        return;
      }
      openMessage("success", res.message);
      onCallbackEdit && onCallbackEdit(getValues());
      setVisible(false);
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
      openMessage("error", (error as Error).message);
    }
  };

  return (
    <Modal
      width={650}
      title={
        (
          <Text size="L" text={`ช่างคอนเฟิร์มรับงาน #${MainId}`} bold />
        ) as React.ReactNode
      }
      visible={visible}
      okText={"บันทึก"}
      cancelText={"ยกเลิก"}
      centered
      onCancel={() => setVisible(false)}
      confirmLoading={loading}
      footer={[
        <ContainerModalFooterSingle key="1">
          <Button
            type="primary"
            loading={loading}
            onClick={handleSubmit(onConfirm, (errors) => console.log(errors))}
          >
            รับงาน
          </Button>
        </ContainerModalFooterSingle>,
      ]}
    >
      <ContainerConfirmGetJob>
        <Text size={"S"} text={`หมายเลขเครืองตัด: ${deviceId}`} />
      </ContainerConfirmGetJob>
      <BaseForm
        control={control}
        forms={FORM_MAINTENANCE_TECH_CONFIRM_GET_JOB()}
        setValue={setValue}
        getValues={getValues}
      />
    </Modal>
  );
});
